const ONE_TO_ONE = 'ONE_TO_ONE';
const isActive = ({
  active
}) => active === true;
const isOneToOne = subscriptionDefinition => subscriptionDefinition.defaultSubscription === ONE_TO_ONE;
const byOrder = (a, b) => a.position - b.position;
const getDefaultSubscriptionId = subscriptionDefinitions => {
  const activeSubscriptions = subscriptionDefinitions.sort(byOrder).filter(isActive);
  const oneToOneSubscription = activeSubscriptions.find(isOneToOne);
  const {
    id
  } = oneToOneSubscription || activeSubscriptions[0] || {};
  return id;
};
export default getDefaultSubscriptionId;